import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuth } from '../../common/auth';
 
export default function PrivateRoute({ children, ...rest }: RouteProps) {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        Boolean(user) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}